/**
 * External dependencies.
 */
import Image from "next/image";
import { createElement } from "react";
import { MediaArrProp } from "types";

/**
 * Internal dependencies.
 */
import { getStrapiMediaArr } from "utils";

interface LogosProp {
  logos: MediaArrProp[];
  item?: any;
}

const Logos: React.FC<LogosProp> = ({ logos, item }) => {
  if (item.hide) {
    return null;
  }
  const heading = createElement(
    item.Type || "h2",
    item.Type ? {} : { className: "h6" },
    item.LogosTitle
  );

  return (
    <div className="logos">
      <div className="container container--small">
        <div
          className="logos__inner"
          style={item.TitleColorHEX ? { color: item.TitleColorHEX } : {}}
        >
          {heading}
        </div>
        <div className="logos__items">
          {logos?.map((item: MediaArrProp, index: number) => (
            <div key={index} className="logo">
              {item && (
                <Image
                  src={getStrapiMediaArr(item)}
                  alt={item.attributes.alternativeText || ""}
                  width={item.attributes.width || 152}
                  height={item.attributes.height || 60}
                  sizes="(max-width: 767px) 81px, 200px"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Logos;
